import { IFeatureBase, IFeatureGroupBase } from '../../models/features';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface ICreateFeatureGroupProps {
  key: string;
  authLevel: number;
  features: IFeatureBase[];
  name: string;
  useExperienceLevel: boolean;
  useFaceId: boolean;
  useOnboardUrl: boolean;
}

export type INewFeatureGroup = IFeatureGroupBase;

export const createFeatureGroupsService = async ({
  authLevel,
  key,
  features,
  name,
  useExperienceLevel,
  useFaceId,
  useOnboardUrl,
}: ICreateFeatureGroupProps): Promise<INewFeatureGroup> => {
  const { data } = await jhsfBookingsApi.post<INewFeatureGroup>(
    '/feature-groups',
    {
      authLevel,
      key,
      features,
      name,
      useExperienceLevel,
      useFaceId,
      useOnboardUrl,
    },
  );

  return data;
};
